import { Link, useMatchRoute } from '@tanstack/react-router'
import { DollarSign, Users, Layers, Menu, Target, Clock, Image as ImageIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useSidebarStore } from '@/stores/sidebar-store'
import { useAuth } from '@/hooks/use-auth'
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet'
import { Button } from '@/components/ui/button'
import { MobileSidebar } from './mobile-sidebar'

interface MobileNavItem {
  label: string
  href: string
  icon: typeof DollarSign
  menuKey: string
}

const allMobileNavItems: MobileNavItem[] = [
  { label: 'Financeiro', href: '/financeiro', icon: DollarSign, menuKey: 'financeiro' },
  { label: 'Clientes', href: '/clientes', icon: Users, menuKey: 'clientes' },
  { label: 'Grupos', href: '/grupos', icon: Layers, menuKey: 'grupos' },
  { label: 'Dados', href: '/dados-historicos', icon: Clock, menuKey: 'dados-historicos' },
  { label: 'Metas', href: '/metas-loja', icon: Target, menuKey: 'metas-loja' },
  { label: 'Metas Ind.', href: '/metas-individuais', icon: Users, menuKey: 'metas-individuais' },
  { label: 'Fotos', href: '/fotos', icon: ImageIcon, menuKey: 'fotos' },
]

export function MobileNav() {
  const { isMobileOpen, setMobileOpen } = useSidebarStore()
  const { hasMenuAccess } = useAuth()
  const matchRoute = useMatchRoute()

  // Filtra itens baseado nos acessos do usuário (máximo 6 para caber na tela + botão Menu)
  const mobileNavItems = allMobileNavItems.filter((item) => hasMenuAccess(item.menuKey)).slice(0, 6)

  return (
    <>
      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 border-t bg-background md:hidden">
        {/* Grid dinâmico: itens filtrados + 1 slot para o botão Menu */}
        <div
          className="grid items-center"
          style={{ gridTemplateColumns: `repeat(${mobileNavItems.length + 1}, 1fr)` }}
        >
          {mobileNavItems.map((item) => {
            const isActive = matchRoute({ to: item.href, fuzzy: true })
            return (
              <Link
                key={item.href}
                to={item.href}
                className={cn(
                  'flex flex-col items-center justify-center gap-0.5 py-2 px-1 min-h-[56px]',
                  isActive ? 'text-primary' : 'text-muted-foreground'
                )}
              >
                <item.icon className="h-5 w-5" />
                <span className="text-[10px] leading-tight text-center truncate w-full">{item.label}</span>
              </Link>
            )
          })}
          <Sheet open={isMobileOpen} onOpenChange={setMobileOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="sm" className="flex flex-col gap-0.5 h-auto py-2 px-1 min-h-[56px] rounded-none">
                <Menu className="h-5 w-5" />
                <span className="text-[10px] leading-tight">Menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="w-72 p-0">
              <MobileSidebar />
            </SheetContent>
          </Sheet>
        </div>
      </nav>

      {/* Add padding to main content on mobile to account for bottom nav */}
      <div className="h-16 md:hidden" />
    </>
  )
}
